import styled from 'styled-components';

import THEME from 'theme';

import { SCREEN } from 'scenes/common/types/screen';

type ContainerProps = {
  border?: boolean;
};

export const SummaryContainer = styled.div`
  ${(props: ContainerProps) =>
    props.border
      ? `border-radius: 6px; border: 1px solid ${THEME.FIELD.BORDER.DEFAULT};`
      : ``}
  padding: 1.5rem;
  @media (max-width: ${SCREEN.EXTRA_SMALL}px) {
    padding: 1rem;
  }
`;

SummaryContainer.defaultProps = {
  border: true,
};

export default SummaryContainer;
